import Splide from "@splidejs/splide";
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

window.addEventListener("load", () => {
    const usps_splides = document.querySelectorAll<HTMLElement>(".usps-splide");
    const logos_splides = document.querySelectorAll<HTMLElement>(".logos-splide");
    const galleryCarousel_splides = document.querySelectorAll<HTMLElement>(".gallery_carousel-splide");
    const review_splides = document.querySelectorAll<HTMLElement>(".reviews-splide");
    const blog_splide = document.querySelector<HTMLElement>(".blog-splide");

    review_splides?.forEach((review_splide) => {
        const splide = new Splide(review_splide, {
                type: 'slide',
                gap: '1rem',
                perPage: 2,
                perMove: 1,
                padding: {
                    right: 'calc(10% + 10vw)',
                    left: 'calc(50vw - 50%)',
                },
                arrows: true,
                pagination: false,
                breakpoints: {
                    767: {
                        perPage: 1,
                    }
                }
            }
        );

        splide.mount();
    });

    usps_splides?.forEach((usps_splide) => {
        const splide = new Splide(usps_splide, {
                type: 'loop',
                gap: '6px',
                perPage: 6,
                autoWidth: true,
                clones: 6,
                autoScroll: {
                    speed: 0.5,
                    pauseOnFocus: false,
                    pauseOnHover: false,
                },
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                drag: false,
                lazyLoad: false,
                breakpoints: {
                    1199: {
                        perPage: 5,
                    },
                    991: {
                        perPage: 4,
                    },
                    767: {
                        perPage: 3,
                    },
                    575: {
                        perPage: 2,
                    },
                }
            }
        );

        splide.mount({AutoScroll});
    });

    logos_splides?.forEach((logo_splide) => {
        const splide = new Splide(logo_splide, {
                type: 'loop',
                gap: '80px',
                perPage: 6,
                autoScroll: {
                    speed: 0.5,
                    pauseOnFocus: false,
                    pauseOnHover: false,
                },
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                drag: false,
                lazyLoad: false,
                breakpoints: {
                    1199: {
                        perPage: 5,
                    },
                    991: {
                        perPage: 4,
                    },
                    767: {
                        perPage: 3,
                    },
                    575: {
                        perPage: 2,
                    },
                }
            }
        );

        splide.mount({AutoScroll});
    });

    galleryCarousel_splides?.forEach((galleryCarousel_splide) => {
        const splide = new Splide(galleryCarousel_splide, {
                type: 'slide',
                gap: '1rem',
                perPage: 1,
                arrows: true,
                pagination: false,
            }
        );

        splide.mount();
    });

    if (blog_splide) {
        const splide = new Splide(blog_splide, {
                type: 'slide',
                gap: '1rem',
                perPage: 1,
                perMove: 1,
                arrows: true,
                pagination: false,
                slideFocus: false,
                focusableNodes: 'a, div, button, img',
            }
        );

        const updateInertAttributes = () => {
            const slides = blog_splide.querySelectorAll<HTMLElement>('.splide__slide');

            slides.forEach(slide => {
                const isHidden = slide.getAttribute('aria-hidden') === 'true';

                if (isHidden) {
                    slide.setAttribute('inert', '');
                    slide.querySelectorAll('a, button').forEach(el => el.setAttribute('tabindex', '-1'));
                } else {
                    slide.removeAttribute('inert');
                    slide.querySelectorAll('a, button').forEach(el => el.removeAttribute('tabindex'));
                }
            });
        };

        splide.on('drag', () => {
            if (document.activeElement && blog_splide.contains(document.activeElement)) {
                (document.activeElement as HTMLElement).blur();
            }
        });

        splide.on('visible', updateInertAttributes);

        splide.mount();
    }
});